var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('vue-modal', {
    ref: _vm.customRef,
    attrs: {
      "adaptive": true,
      "classes": _vm.customClass,
      "click-to-close": _vm.clickToClose,
      "height": _vm.modalHeight,
      "max-width": _vm.maxWidth,
      "name": _vm.name,
      "pivotY": 0.15,
      "scrollable": _vm.scrollable,
      "width": _vm.width,
      "role": "dialog",
      "aria-modal": "true",
      "aria-describedby": _vm.dialogDesc && 'customs-vmodal-dialog-desc',
      "aria-labelledby": _vm.modalTitle && 'customs-vmodal-header-title'
    },
    on: {
      "before-open": _vm.beforeOpen,
      "before-close": _vm.beforeClose,
      "closed": _vm.closed
    }
  }, [_c('focus-trap', {
    attrs: {
      "active": _vm.isActive
    }
  }, [_vm._t("default")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }